export default __webpack_public_path__ + "static/media/Cp_background_Sanic.2fb13a8c.png";